import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "#overview" }, null, -1)
const _hoisted_6 = { class: "py-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-4" }, " Each update should be used independently without mixing it with the previous versions. This is because new updates may not have a 100% backward compatibility for elements within previous versions. Therefore, each update is considered as a new and better version of the theme. ", -1)
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = { class: "py-2" }
const _hoisted_12 = { class: "py-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("li", { class: "py-2" }, " Get the latest version use it instead the previous version. ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("li", { class: "py-2" }, [
  /*#__PURE__*/_createTextVNode(" Run "),
  /*#__PURE__*/_createVNode("code", null, "yarn install"),
  /*#__PURE__*/_createTextVNode(" task to update 3rd party plugins with their latest versions. ")
], -1)
const _hoisted_15 = { class: "py-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("li", { class: "py-2" }, " Manually replace the element HTML, CSS or JS where necessary. ", -1)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" If something goes wrong, you can revert your updates by reusing your backup files. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" Updating  " + _toDisplayString(_ctx.themeName), 1)
        ]),
        _createVNode("div", _hoisted_6, " Like all HTML templates, you will need to manually handle all updates that we provide after purchase for free. The best practice is to always keep " + _toDisplayString(_ctx.themeName) + "'s source folder on an entire separate folder within your project and then use " + _toDisplayString(_ctx.themeName) + " as a development companion or support. ", 1),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createTextVNode(" Here's our recommended steps needed to update " + _toDisplayString(_ctx.themeName) + " effectively: ", 1),
          _createVNode("ol", _hoisted_9, [
            _createVNode("li", _hoisted_10, " Backup all your files (your project folder and " + _toDisplayString(_ctx.themeName) + "'s's older version). ", 1),
            _createVNode("li", _hoisted_11, " Review " + _toDisplayString(_ctx.themeName) + "s changelog to have a quick preview on what has been updated. ", 1),
            _createVNode("li", _hoisted_12, " Unzip the latest version of " + _toDisplayString(_ctx.themeName) + " and then browse through the elements (layout, widgets, plugins, etc) that you have used on your project. ", 1),
            _hoisted_13,
            _hoisted_14,
            _createVNode("li", _hoisted_15, " Compare your project's code vs the latest version of " + _toDisplayString(_ctx.themeName) + "s code for the used elements. ", 1),
            _hoisted_16,
            _createVNode("li", _hoisted_17, " Save and test your project files with " + _toDisplayString(_ctx.themeName) + "'s updated elements. ", 1)
          ]),
          _hoisted_18
        ])
      ])
    ])
  ]))
}